import { FilterItemDto } from '@/app/common/general-types/filters.dto';

/** Needs-you rows first, then most recent. Mirrors the API's `needsYou` sort key. */
export const ASSIGNMENT_DEFAULT_SORT: FilterItemDto = {
  id: 'needs-you',
  name: 'Needs you first',
  value: 'needsYou',
  direction: 'DESC',
  description: 'Creators waiting on you, then the most recent',
};

export const ASSIGNMENT_RECENT_SORT: FilterItemDto = {
  id: 'recent',
  name: 'Latest activity',
  value: 'applicationStatusModifiedDate',
  direction: 'DESC',
  description: 'Most recently updated applications first',
};

export const ASSIGNMENT_PROGRESS_SORT_OPTIONS: FilterItemDto[] = [
  {
    id: 'furthest',
    name: 'Furthest along',
    value: 'stageRank',
    direction: 'DESC',
    description: 'Completed first, invited last',
  },
  {
    id: 'followers',
    name: 'Most followers',
    value: 'followers',
    direction: 'DESC',
    description: 'TikTok, Instagram and YouTube followers combined',
  },
];

export const ASSIGNMENT_NAME_SORT_OPTIONS: FilterItemDto[] = [
  {
    id: 'name-asc',
    name: 'Name A–Z',
    value: 'creator.firstName',
    direction: 'ASC',
    description: 'Sort by first name, then last name',
  },
];

export const ASSIGNMENT_EXPIRY_SORT_OPTIONS: FilterItemDto[] = [
  {
    id: 'expiry-asc',
    name: 'Expires soonest',
    value: 'autoDeclineAt',
    direction: 'ASC',
    description: 'Applied creators whose auto-decline is closest',
  },
];

export function isExpirySort(option: FilterItemDto | null | undefined): boolean {
  return option?.value === 'autoDeclineAt';
}

export function assignmentSortOptions(hasAppliedApplicants: boolean): FilterItemDto[] {
  return [
    ASSIGNMENT_DEFAULT_SORT,
    ASSIGNMENT_RECENT_SORT,
    ...ASSIGNMENT_PROGRESS_SORT_OPTIONS,
    ...ASSIGNMENT_NAME_SORT_OPTIONS,
    ...(hasAppliedApplicants ? ASSIGNMENT_EXPIRY_SORT_OPTIONS : []),
  ];
}

export function isSameAssignmentSort(
  a: FilterItemDto | null | undefined,
  b: FilterItemDto | null | undefined,
): boolean {
  return a?.id === b?.id && a?.value === b?.value && a?.direction === b?.direction;
}
